export const GET_NAC_AUTOMATION_LOGS = {
    INIT : "GET_NAC_AUTOMATION_LOGS_INIT",
    SUCCESS : "GET_NAC_AUTOMATION_LOGS_SUCCESS",
    ERROR : "GET_NAC_AUTOMATION_LOGS_ERROR",
}

export const GET_NAC_AUTOMATION_DETAILS_BY_RITM = {
    INIT : "GET_NAC_AUTOMATION_DETAILS_BY_RITM_INIT",
    SUCCESS : "GET_NAC_AUTOMATION_DETAILS_BY_RITM_SUCCESS",
    ERROR : "GET_NAC_AUTOMATION_DETAILS_BY_RITM_ERROR",
}

export const GET_NAC_AUTOMATION_EVENTS_BY_RITM = {
    INIT : "GET_NAC_AUTOMATION_EVENTS_BY_RITM_INIT",
    SUCCESS : "GET_NAC_AUTOMATION_EVENTS_BY_RITM_SUCCESS",
    ERROR : "GET_NAC_AUTOMATION_EVENTS_BY_RITM_ERROR",
}